import { ProgrammingStructureStage } from "@models/ISchema";
import { AdaptedStageOption } from "@services/types/programming-structures/programmingStructuresTypes";

export const getStagesAsSelectorOption = (stage: ProgrammingStructureStage): AdaptedStageOption => {
  return {
    label: `${stage.code} - ${stage.name}`,
    value: stage.id,
    self: stage,
  };
};

export const getStagesAsSelectorOptions = (
  stages: ProgrammingStructureStage[] = [],
): AdaptedStageOption[] => {
  return stages.map(getStagesAsSelectorOption);
};
